var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0498 11.25C8.63559 11.25 8.2998 11.5858 8.2998 12C8.2998 12.4142 8.63559 12.75 9.0498 12.75H15.7998V17.625C15.7983 19.0741 14.6239 20.2484 13.1748 20.25H5.6748C4.2257 20.2484 3.05135 19.0741 3.0498 17.625V6.375C3.05135 4.9259 4.2257 3.75155 5.6748 3.75H12.7998C14.2159 3.75 15.7998 4.875 15.7998 6.375V11.25H9.0498ZM15.7998 11.25V12.75H19.989L17.5196 15.2198C17.3221 15.4076 17.2419 15.6877 17.3102 15.9515C17.3784 16.2153 17.5845 16.4214 17.8483 16.4897C18.1121 16.5579 18.3923 16.4777 18.58 16.2802L22.33 12.5302C22.6226 12.2373 22.6226 11.7627 22.33 11.4698L18.58 7.71984C18.2851 7.4397 17.8207 7.44564 17.5331 7.73325C17.2454 8.02085 17.2395 8.48528 17.5196 8.78016L19.989 11.25H15.7998Z",
    fill: "#1C1C1C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.acd0b13e504f4d9769c3dda09f7cd7b0.svg";
export { ForwardRef as ReactComponent };